export default "__VITE_ASSET__3c71df2a__"